<template> <el-card>
  <el-form :model="info" ref="info" :rules="rules" label-width="80px" class="global-form2">
    <el-form-item label="姓名" prop="userName">
      <el-input v-model="info.userName" placeholder="请输入姓名" maxlength="50"></el-input>
    </el-form-item>
    <el-form-item label="所属组织" prop="deptId">
      <el-cascader
        v-model="deptId"
        :options="deptList"
        :props="prop"
        placeholder="请选择所属组织"
        @change="deptChange"
        >
      </el-cascader>
    </el-form-item>
    <el-form-item label="角色" prop="roleId">
      <el-select v-model="info.roleId" placeholder="请选择角色" @change="userChange">
        <el-option v-for="(item,index) in roleList" :label="item.roleName" :value="item.roleId" :key="index"></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="手机号码" prop="mobile">
      <el-input v-model="info.mobile" placeholder="请输入手机号码" maxlength="50"></el-input>
    </el-form-item>
    <el-form-item label="登录账号" prop="loginId">
      <el-input v-model="info.loginId" placeholder="请输入登录账号" maxlength="50" :disabled="$route.params.id?false:false"></el-input>
    </el-form-item>
    <el-form-item label="密码" prop="roleName">
      <el-button v-if="$route.params.id" type="text" @click="resetPassword">重置密码</el-button>
      <p v-else>默认手机号后六位</p>
    </el-form-item>
    <el-form-item label="关联项目" prop="projectIdList">
      <span v-if="dataPermission === '1'">全部项目</span>
      <div class='checkbox' v-else>
        <el-checkbox-group v-model="info.projectIdList">
          <el-checkbox v-for="(item,index) in projectList" :key="index" :label="item.projectId">{{item.projectName}}</el-checkbox>
        </el-checkbox-group>
    </div>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="onSubmit" :disabled="submitShow">保存</el-button>
      <el-button @click="$router.push({name:'department'})">取消</el-button>
    </el-form-item>
  </el-form>
</el-card>
</template>

<script>
import { validPhoneNumber } from '@/utils/validate'
export default {
  name: 'PersonnelAdd',
  data () {
    return {
      info: {
        userName: '',
        mobile: '',
        roleId: '',
        deptId: '',
        loginId: '',
        projectIdList: []
      },
      rules: {
        userName: [{ required: true, message: '请输入姓名', trigger: ['blur', 'change'] }],
        deptId: [{ required: true, message: '请选择所属组织', trigger: ['change'] }],
        roleId: [{ required: true, message: '请选择角色', trigger: ['change'] }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: ['blur', 'change'] },
          { validator: validPhoneNumber, trigger: ['blur', 'change'] }
        ],
        loginId: [{ required: true, message: '请输入登录账号', trigger: ['blur', 'change'] }]
      },
      deptId: '',
      deptList: [],
      roleList: [],
      dataPermission: '',
      prop: {
        expandTrigger: 'hover',
        value: 'deptId',
        label: 'deptName',
        children: 'childNode',
        emitPath: false
      },
      submitShow: false,
      projectCheckList: []
    }
  },
  computed: {
    id () {
      return this.$route.params.id
    },
    projectList () {
      return this.$store.state.projectList
    }
  },
  created () {
    this.deptGet()
    this.roleListGet()
    if (this.id) {
      this.dataGet()
    }
  },
  methods: {
    deptGet () {
      this.$axios.get(this.$apis.system.departmentList).then((res) => {
        this.deptList = res || []
      })
    },
    roleListGet () {
      this.$axios.get(this.$apis.system.getRoleList).then((res) => {
        this.roleList = res || []
      })
    },
    userChange (id) {
      const row = this.roleList.find(item => item.roleId === id)
      if (row) {
        this.dataPermission = row.dataPermission
      }
    },
    dataGet () {
      this.$axios.get(this.$apis.system.personnelDetail, {
        userId: this.id
      }).then((res) => {
        this.info = {
          userName: res.userName || '',
          mobile: res.mobile || '',
          roleId: res.roleId || '',
          deptId: res.deptId || '',
          loginId: res.loginId || '',
          userId: res.userId || '',
          projectIdList: res.projectIdList || []
        }
        console.log(this.info)
        this.userChange(this.info.roleId)
        this.deptId = res.deptId
      })
    },
    deptChange () {
      this.info.deptId = this.deptId ? this.deptId : ''
    },
    resetPassword () {
      this.$axios.post(this.$apis.system.resetPassword, {
        userId: this.id
      }).then(() => {
        this.$message.success('重置成功')
      }).catch((err) => {
        this.$message(err)
      })
    },
    onSubmit () {
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.submitShow = true
          const url = this.id
            ? this.$apis.system.personnelUpdate
            : this.$apis.system.personnelAdd
          this.$axios.post(url, this.info).then((res) => {
            this.$message.success('保存成功')
            this.$router.push({ name: 'department' })
          }).catch(() => {
            this.submitShow = false
          })
        }
      })
    }

  }
}
</script>

<style scoped lang='scss'>
.checkbox {
    width: 380px;
    max-height: 200px;
    overflow-y: auto;
    display:flex;
    flex-direction:column;
    .el-checkbox {
      display: flex;
      align-items: center;
      margin: 7px 0;
    }
    ::v-deep .el-checkbox__label {
      width: 340px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap
    }
  }
</style>
